import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

// Base URL is now set in utils/axiosConfig.js

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showTutorial, setShowTutorial] = useState(false);
  const [tutorialStep, setTutorialStep] = useState(0);
  const [needsPasswordChange, setNeedsPasswordChange] = useState(false);

  // Load user on initial render if token exists
  useEffect(() => {
    loadUser();
  }, []);
  
  const loadUser = async (forceReload = false) => {
    const token = localStorage.getItem('token');
    
    if (!token) {
      setLoading(false);
      return;
    }
    
    // Set auth token header
    axios.defaults.headers.common['x-auth-token'] = token;
    
    try {
      const res = await axios.get('/api/auth/user');
      setIsAuthenticated(true);
      setUser(res.data);
      
      // Check if this is the user's first login
      if (res.data.isFirstLogin) {
        console.log('First login detected');
        setNeedsPasswordChange(true);
      } else {
        setNeedsPasswordChange(false);
      }
    } catch (err) {
      console.error('Error loading user:', err.message);
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['x-auth-token'];
    }
    
    setLoading(false);
  };

  // Logout function
  const logout = () => {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common['x-auth-token'];
    setIsAuthenticated(false);
    setUser(null);
    setShowTutorial(false);
    setTutorialStep(0);
  };
  
  // Update token function
  const updateToken = (newToken) => {
    if (newToken) {
      localStorage.setItem('token', newToken);
      axios.defaults.headers.common['x-auth-token'] = newToken;
    }
  };
  
  // Complete tutorial
  const completeTutorial = () => {
    setShowTutorial(false);
    setTutorialStep(0);
    // Update user in database to mark tutorial as completed
    if (user && user._id) {
      axios.post('/api/users/complete-tutorial', { userId: user._id })
        .catch(err => console.error('Error marking tutorial as completed:', err));
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated,
        user,
        setUser,
        loading,
        logout,
        updateToken,
        loadUser,
        showTutorial,
        setShowTutorial,
        tutorialStep,
        setTutorialStep,
        completeTutorial,
        needsPasswordChange,
        setNeedsPasswordChange
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
